import HttpClientToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { ActualizarApiKeyEstatusParams, ActualizarApiKeyParams, ActualizarApiKeyResponse, AgregarApiKeyParams, AgregarApiKeyResponse, ApiKeyProps, defaultActualizarApiKey, defaultAgregarApiKey } from '../../interfaces/admin/ApiKeysInterface';

export const ObtenerApiKeys = () => {

    return new Promise<ApiKeyProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ApiKeys/ObtenerApiKeys/', null, token)
            .then( ({ data } : { data : ApiKeyProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarApiKeyEstatus = ( params: ActualizarApiKeyEstatusParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ApiKeys/ActualizarApiKeyEstatus/', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const AgregarApiKey = ( params: AgregarApiKeyParams ) => {

    return new Promise<AgregarApiKeyResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ApiKeys/AgregarApiKey/', params, token)
            .then( ({ data } : { data : AgregarApiKeyResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultAgregarApiKey, message: error.message } );
            });

        }

    });

}

export const ActualizarApiKey = ( params: ActualizarApiKeyParams ) => {

    return new Promise<ActualizarApiKeyResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ApiKeys/ActualizarApiKey/', params, token)
            .then( ({ data } : { data : AgregarApiKeyResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultActualizarApiKey, message: error.message } );
            });

        }

    });

}
